import { useCmsMemberInfo } from '@doda/common/src/hooks/useCmsMemberInfo';
import { useAnalyticsSetup } from '@doda/common/src/hooks/useAnalytics';

/** クライアントでの画面初期化処理 */
export function useInitializeOnClient() {
  useCmsMemberInfo('pcHeader');
  useAnalyticsSetup();
}
